import React from "react";
import TextInputTwoRow from "components/GenericComponent/TextInputTwoRow";
import { AutoCompleteChuNho } from "./AutoCompleteChuNo";
import UploadCustomerImage from "components/GenericComponent/UploadCustomerImage";
import DateTimePicker from "components/GenericComponent/DateTimePicker";

export const ChuNo = ({ chunovalue, updateChuNo, IsEdit }) => {
  //alert(chunovalue.Phone);
  const register = () => {};
  const updateTextValue = (field) => (e) => {
    updateChuNo({
      ...chunovalue,
      [field]: e.target.value,
    });
  };
  const updateChuNoSelect = (valueSelect) => {
    updateChuNo(valueSelect);
  };
  const control = () => {};
  const onChangeImg = (val) => {
    updateChuNo({
      ...chunovalue,
      Img: val,
    });
  };
  const onChangeDate = (field) => (evt) => {
    updateChuNo({
      ...chunovalue,
      [field]: evt,
    });
  };
  return (
    <>
      <div
        id="headingCollapse196"
        className="card-header "
        data-toggle="collapse"
        href="#collapse196"
        aria-expanded="true"
        aria-controls="collapse196"
      >
        <a className="card-title lead info collapsed" href={() => false}>
          <h3>Thông tin chủ nợ</h3>
        </a>
      </div>
      <div
        id="collapse196"
        role="tabpanel"
        aria-labelledby="headingCollapse96"
        className="card-collapse collapse show"
      >
        <div class="card-content">
          <div class="card-body">
            <div class="thong-tin-khach-vay">
              <div class="row col-md-12">
                <div className="col-md-3" style={{ marginRight: "-45px" }}>
                  <div className="col-md-12 no-image1">
                    <div className="col-md-12">
                      <div>
                        <UploadCustomerImage
                          onChange={onChangeImg}
                          image={chunovalue.Img}
                          Code={""}
                        ></UploadCustomerImage>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-9">
                  <div className="row" style={{ marginTop: "20px" }}>
                    <div class="col-md-3">
                      <AutoCompleteChuNho
                        CustomerID={1}
                        CustomerName={"thuty"}
                        IsEditCustomer={IsEdit}
                        control={control}
                        updateChuNoSelect={updateChuNoSelect}
                        chunovalue={chunovalue}
                        updateChuNo={updateChuNo}
                      />
                    </div>
                    <div class="col-md-3">
                      <TextInputTwoRow
                        labelClass="col-md-4 label-control"
                        inputClass="form-control input-sm"
                        inputWrapClass="col-md-8"
                        wrapperClass="form-group row"
                        labelText="Số điện thoại"
                        inputProps={{
                          name: "customer.Phone",
                          ref: register,
                          onChange: updateTextValue("Phone"),
                          value: chunovalue.Phone,
                        }}
                      ></TextInputTwoRow>
                    </div>
                    <div class="col-md-3">
                      <TextInputTwoRow
                        labelClass="col-md-4 label-control"
                        inputClass="form-control input-sm"
                        inputWrapClass="col-md-8"
                        wrapperClass="form-group row"
                        labelText="Địa chỉ"
                        inputProps={{
                          name: "customer.Address",
                          ref: register,
                          onChange: updateTextValue("Address"),
                          value: chunovalue.Address,
                        }}
                      ></TextInputTwoRow>
                    </div>
                    <div class="col-md-3">
                      <label className="label-control color7-bold">
                        Ngày sinh
                      </label>
                      <br />
                      <div>
                        <DateTimePicker
                          onChange={onChangeDate("Birthday")}
                          value={chunovalue.Birthday}
                          name="chunovalue.Birthday"
                          customInputRef={register}
                          customInput={
                            <input
                              name="chunovalue.Birthday"
                              ref={register}
                            ></input>
                          }
                        ></DateTimePicker>
                      </div>
                    </div>
                  </div>
                  <div
                    className="row"
                    style={{ marginTop: "20px", marginBottom: "20px" }}
                  >
                    <div className="col-md-3">
                      <TextInputTwoRow
                        labelClass="col-md-4 label-control"
                        inputClass="form-control input-sm"
                        wrapperClass="form-group row"
                        labelText="Số CCCD"
                        inputWrapClass="col-md-8"
                        inputProps={{
                          name: "chunovalue.CMT",
                          ref: register,
                          onChange: updateTextValue("CMT"),
                          value: chunovalue.CMT,
                        }}
                      ></TextInputTwoRow>
                    </div>
                    <div class="col-md-3">
                      <label className="label-control color7-bold">
                        Ngày cấp
                      </label>
                      <br />
                      <div>
                        <DateTimePicker
                          onChange={onChangeDate("DateCMT")}
                          value={chunovalue.DateCMT}
                          name="chunovalue.DateCMT"
                          customInputRef={register}
                          customInput={
                            <input
                              name="chunovalue.DateCMT"
                              ref={register}
                            ></input>
                          }
                        ></DateTimePicker>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <TextInputTwoRow
                        labelClass="col-md-4 label-control"
                        inputClass="form-control input-sm"
                        wrapperClass="form-group row"
                        labelText="Nơi cấp"
                        inputWrapClass="col-md-8"
                        inputProps={{
                          name: "chunovalue.AddressCMT",
                          ref: register,
                          onChange: updateTextValue("AddressCMT"),
                          value: chunovalue.AddressCMT,
                        }}
                      ></TextInputTwoRow>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
